$(document).ready(function(){

    function initSlider(){
        if ($(window).width() <= 1024) {

            if (!$('.block__mntn-attention-wrapper').hasClass('slick-initialized')) {

                
                $('.block__mntn-attention-wrapper').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    customPaging: function() { return '<button></button>'; }, 
                    speed: 600,
                    arrows: false,
                    dots: true,
                    draggable: false
                });
            }

        } else {

            $('.block__mntn-attention-wrapper').css(
                    'height',
                    $('.block__mntn-attention-wrapper > div:first-child').innerHeight() + 40
                );


            if ($('.block__mntn-attention-wrapper').hasClass('slick-initialized')) {
                $('.block__mntn-attention-wrapper').slick('unslick');
            }

        }
    }

    initSlider();

    $(window).on('resize', function(){
        initSlider();
    });

});